import diagnosticsServiceTestResponse from "@/model/disgnostics_service_test_response"
import configurationInventoryResponse from "@/model/configuration_service_inventory_response"
import inventoryResponse from "@/model/inventory_response"

export default {
  diagnosticsServiceTestResponse,
  configurationInventoryResponse,
  inventoryResponse
};
